import { Link } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';

import { iconFill, mediaQuery } from '../../styles/mixin';
import { Icon } from '../Icon';

const OVERFLOW_THRESHOLD = 10;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;
    margin-bottom: 2.813rem;
    ${mediaQuery(
        2,
        css`
            margin-bottom: 0;
        `
    )}
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

interface ILaneContainer {
    maxWidth: number;
}

export const LaneContainer = styled.div<ILaneContainer>`
    overflow: scroll;
    padding-left: ${OVERFLOW_THRESHOLD}px;
    margin: -${OVERFLOW_THRESHOLD}px;
    padding-bottom: 0.5rem;
    ${mediaQuery(
        2,
        css`
            overflow: unset;
        `
    )}
`;

export const Lane = styled.ul`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    column-gap: 1.5rem;
    width: 100%;
    min-width: 850px;
    margin: 1rem 0 0.75rem;
`;

export const ViewAll = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    padding-right: 0.5rem;
    ${mediaQuery(
        2,
        css`
            padding-right: 0;
        `
    )}
`;

export const StyledIcon = styled(Icon)`
    width: ${({ theme }) => theme.fontSizes[2]};
    height: ${({ theme }) => theme.fontSizes[2]};
    margin: 0 0 0 0.25rem;
    transition: all ${({ theme }) => theme.transitions.hover};
`;

export const StyledLink = styled(Link)`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${({ theme }) => theme.colors.fontSecondary};
    font-size: ${({ theme }) => theme.fontSizes[3]};
    transition: all ${({ theme }) => theme.transitions.hover};

    &:hover {
        color: ${({ theme }) => theme.colors.logoPrimary};

        ${StyledIcon} {
            ${({ theme }) => iconFill(theme.colors.logoPrimary)};
        }
    }
`;

export const EmptyStateMsg = styled.div`
    height: 10rem;
    display: flex;
    align-items: center;
`;

const LaneLoaderAnimation = keyframes`
    0% {
        background-position: 0 0;
    }

    50% {
        background-position: 50% 0;
    }

    100% {
        background-position: 100% 0;
    }
`;

export const LaneLoader = styled.div`
    height: 10rem;
    width: 100%;
    display: flex;
    background: linear-gradient(90deg, #f7f8fa, #ebecf3, #f7f8fa, #ebecf3);
    background-size: 400%;
    animation: ${LaneLoaderAnimation} 2s ease infinite forwards;
`;
